import type { RegistrationStateType } from './RegistrationState'

export function toRegistrationState({
  hasEnded,
  isUserRegistered,
  isUserSelfReserved,
  isEnrollmentClosed = false,
}: {
  hasEnded: boolean
  isUserRegistered: boolean
  isUserSelfReserved: boolean
  isEnrollmentClosed?: boolean
}): RegistrationStateType {
  if (hasEnded) {
    return 'ended'
  }
  if (isUserRegistered) {
    return 'registered'
  }
  if (isEnrollmentClosed) {
    return 'closed'
  }
  if (isUserSelfReserved) {
    return 'reserved'
  }
  return 'open'
}
